import React from "react";
import { GoogleAuthProvider, signInWithPopup, getAuth } from "@firebase/auth";
import { app } from "./firebase";
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from "../../store/authStore";
import { useAlert } from "../../context/AlertContext";


export default function GoogleAuth() {
    const navigate = useNavigate();
    const { setTokens } = useAuthStore();
    const setAlert = useAlert();

    const handleGoogleClick = async () => {
        try {
            const provider = new GoogleAuthProvider();
            const auth = getAuth(app);
            const result = await signInWithPopup(auth, provider);

            console.log("result", result)

            // Parse displayName into firstName and lastName
            const nameParts = result.user.displayName ? result.user.displayName.trim().split(' ') : ['User', 'User'];
            const firstName = nameParts[0] || 'User';
            const lastName = nameParts.slice(1).join(' ') || nameParts[0] || 'User';

            const res = await fetch(`https://hellocer-backend.onrender.com/api/auth/google`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firstName,
                    lastName,
                    email: result.user.email,
                    profilePicture: result.user.photoURL,
                }),
            });
            const response = await res.json();
            console.log(response);

            if (response.success) {
                const { accessToken, refreshToken, user } = response;
                const { role } = response.user;

                setTokens({
                    accessToken,
                    refreshToken,
                    role,
                    user
                });

                if (setAlert) {
                    setAlert({ type: 'success', message: `Welcome ${response.user.firstName}!` });
                }
                navigate('/clients/dashboard');
            } else {
                if (setAlert) {
                    setAlert({ type: 'error', message: response.error || 'Google login failed' });
                }
            }
        } catch (error) {
            console.log("Could not login with google", error);
            if (setAlert) {
                setAlert({ type: 'error', message: 'Google login failed' });
            }
        }
    }




    return (
    
           <button
              type="button"
               onClick={handleGoogleClick}
              className="w-full md:w-1/2 flex items-center justify-center py-3 px-4 border border-[#666464]  hover:bg-gray-50 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                <path
                  d="M12.545, 10.239v3.821h5.445c-0.712, 2.315-2.647, 3.972-5.445, 3.972-3.332, 0-6.033-2.701-6.033-6.032s2.701-6.032, 6.033-6.032c1.498, 0, 2.866, 0.549, 3.921, 1.453l2.814-2.814C17.503, 2.988, 15.139, 2, 12.545, 2 7.021, 2, 2.543, 6.477, 2.543, 12s4.478, 10, 10.002, 10c8.396, 0, 10.249-7.85, 9.426-11.748l-9.426, -0.013z"
                  fill="#666464"
                />
              </svg>
              Log in with Google
            </button>
    )
}